import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import { ButtonSelect, ButtonTextSelectControl } from '../../../Select'

import * as styles from './BirdviewChartControlSelect.module.css'

function BirdviewChartControlSelect({ options, qaName, value, onSelect }) {
  return (
    <ButtonSelect
      Control={ButtonTextSelectControl}
      className={styles.select}
      controlProps={{
        buttonProps: {
          Button: Button.Outlined,
          height: BUTTON_HEIGHT_32,
          text: value.label,
        },
      }}
      dropdownFloatingConfig={{
        dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.bottomEnd,
        maxWidthByRef: false,
      }}
      filter={null}
      listProps={{ className: styles.list, headerProps: { Search: null } }}
      options={options}
      qaName={qaName}
      value={value}
      onSelectItem={onSelect}
    />
  )
}

export default BirdviewChartControlSelect
